import {ref} from 'vue'
// import axios from 'axios'
import {BASE_URL} from "@/composables/url_config";
// import {useStore} from "vuex";
import {log} from "@/composables/useLog"
import axios from "axios";
// import store from "@/store";
const error = ref(null)
// const token=store.getters.getToken
// log("am citit token din store si am primit: "+token)

export const getClientsList= async (token,client_id="", client_type="")=>{
    log("welcome in  getClientsList from web")
    if(!token || token==""){
        alert("No token in getClientsList")
    }
    try{
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("g1")
        log("BASE_URL="+BASE_URL)
        let url=BASE_URL+'/home/getClientsListApi'
        log("url="+url)
        const params = {
            client_id: client_id,
            client_type: client_type,
        };
        const result= await axios.get(url,  {headers: headers, params})
        log("g2")
        log("result.data din axios getClientsList")
        log(result.data)
        log("g3")
        return result.data
    }catch(err){
        alert("alerta de eroare get getClientsList")
        log(err.value)
        // error.value = err.message
        return {error:true, message:"eroare la getClientsList",clientsList:{}}
    }
}

export const getClientServices= async (token, client_id="")=>{
    log("welcome in getClientServices from web for client_id=" + client_id)
    if(!token || token==""){
        alert("No token in getClientServices")
        return {error:true, message:"No token", client_services:[]}
    }
    try{
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url=BASE_URL+'/home/get_client_services_list_api'
        log("url="+url)
        const params = {
            subclient_id: client_id,
            include_subclients: false,
        };
        const result= await axios.get(url, {headers: headers, params})
        log("result.data din axios getClientServices")
        log(result.data)
        return result.data
    }catch(err){
        alert("Eroare la getClientServices")
        log(err)
        return {error:true, message:"eroare la getClientServices", client_services:[]}
    }
}

export const getClientDetails= async (token,client_id)=>{
    log("welcome in  getClientDetails from web for client_id="+client_id)
    if(!token || token == ""){
        alert("No token in getClientDetails")
    }
    try{
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("g1")
        log("BASE_URL="+BASE_URL)
        let url=BASE_URL+'/home/getClientDetailsApi'
        log("url="+url)
        const params = {
            client_id: client_id,
        };
        const result= await axios.get(url,  {headers: headers, params})
        log("g2")
        log("result.data din axios getClientDetails")
        log(result.data)
        log("g3")
        return result.data
    }catch(err){
        alert("alerta de eroare get getClientDetails")
        log(err.value)
        // error.value = err.message
        return {error:true, message:"eroare la getClientDetails",clientsList:{}}
    }
}

export const getClientTree= async (token,client_id)=>{
    log("welcome in  getClientTree from web")
    if(!token || token == ""){
        alert("No token in getClientTree")
    }
    try{
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("g1 - getClientTree")
        log("BASE_URL="+BASE_URL)
        let url=BASE_URL+'/home/getClientTreeApi'
        log("url="+url)
        const params = {
            client_id: client_id,
        };
        const result= await axios.get(url,  {headers: headers, params})
        log("g2 - getClientTree")
        log("result.data din axios getClientTree")
        log(result.data)
        log("g3 - getClientTree")
        return result.data
    }catch(err){
        alert("alerta de eroare get getClientTree")
        log(err.value)
        // error.value = err.message
        return {error:true, message:"eroare la getClientTree",clients_list:[]}
    }
}
export const getClientUsers= async (token, client_id, options = {})=>{
    log("welcome in  getClientUsers from web")
    if(!token || token == ""){
        alert("No token in getClientUsers")
    }
    try{
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("g1 - getClientUsers")
        log("BASE_URL="+BASE_URL)
        let url=BASE_URL+'/home/getClientUsers'
        log("url="+url)
        const params = {
            client_id: client_id,
        };
        if (options.include_subclients !== undefined) {
            params.include_subclients = options.include_subclients
        }
        if (options.subclient_id) {
            params.subclient_id = options.subclient_id
        }
        if (options.status_filter) {
            params.status_filter = options.status_filter
        }
        const result= await axios.get(url,  {headers: headers, params})
        log("g2 - getClientUsers")
        log("result.data din axios getClientUsers")
        log(result.data)
        log("g3 - getClientUsers")
        return result.data
    }catch(err){
        alert("alerta de eroare get getClientUsers")
        log(err.value)
        // error.value = err.message
        return {error:true, message:"eroare la getClientUsers",users:[]}
    }
}

export const updateClientDistributorStatus = async (token, client_id, is_distributor) => {
    log("welcome in updateClientDistributorStatus")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        const url = BASE_URL + '/home/updateClientDistributorStatusApi'
        const result = await axios.post(url, { client_id, is_distributor }, { headers })
        log("result.data din axios updateClientDistributorStatus")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in updateClientDistributorStatus")
        log(err)
        return { error: true, message: "Error updating distributor status" }
    }
}

const useGetClientsAPI = () => {
    return { error, getClientsList, getClientDetails, getClientServices, getClientTree, getClientUsers, updateClientDistributorStatus };
}
export default useGetClientsAPI
